import { Box, Button, CardMedia, Container, Typography } from "@mui/material";

export const NotFound = () => {
  // @TODO Create a 404 page
  return (
    <>
      <Container>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            height: "100vh",
          }}>
          <Box>
            <CardMedia
              component="img"
              sx={{ width: "150px", height: "50px" }}
              image={process.env.PUBLIC_URL + "/img/logo_ubp_removebg.png"}
              alt="logo"
            />
          </Box>
          <h1>404</h1>
          <Typography
            sx={{
              color: "text.secondary",
            }}>
            Page not found
          </Typography>
          <Box sx={{ mt: 2 }}>
            <Button variant="contained" href="/" color="success">
              Go back Home
            </Button>
          </Box>
          <Typography
            sx={{
              mt: 3,
              display: "flex",
              justifyContent: "center",
              fontSize: "9px",
              fontStyle: "italic",
            }}>
            V.{process.env.REACT_APP_VERSION} Toolapp 2025
          </Typography>
        </Box>
      </Container>
    </>
  );
};
